import { call, put, takeLatest, all, cancelled, select } from "redux-saga/effects"
import { orderBy, find, map, filter, isEmpty, flatMap, sum } from "lodash"
import { push } from "connected-react-router"
import axios from "axios"
import { message } from "antd"
import { editScheduleMeasureSegment } from "../../utils/segment/Measure/measureTrack"
import { generateTree, addLevel } from "../../utils/utils"
import { sendTestMeasure } from "../../services/measurement-create"
import { exportReport } from "../../services/report-page"
import catchError from "../../utils/catchError"

import {
  GET_DIMENSIONS_WATCHER,
  GET_STATUS_WATCHER,
  GET_DIVISIONS_MEASURE_WATCHER,
  GET_QUALITATIVE_QUES_WATCHER,
  GET_DATE_PROG_WATCHER,
  EDIT_MEASUREMENT_NAME_WATCHER,
  DELETE_MEASURE_WATCHER,
  RESEND_SURVEY_WATCHER,
  GET_RECIPIENTS_WATCHER,
  POST_RECIPIENTS_WATCHER,
  GET_DATES_WATCHER,
  EDIT_DATES_WATCHER,
  DOWNLOAD_RECIPIENTS_WATCHER,
  GET_SURVEYS_TYPE_WATCHER,
  GET_LEADERS_DETAILS_WATCHER,
  SEND_TEST_MEASURE_WATCHER,
  POST_EXPORT_REPORT_WATCHER,
  DELETE_CD_WATCHER,
  RESEND_CD_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_RECIPIENTS_SEGMENTS_WATCHER,
  GET_LEADERS_SEGMENTS_WATCHER,
  GET_POSSIBLE_RECIPIENTS_WATCHER,
  ADD_COLLABORATORS_WATCHER,
  GET_MEASURE_ENGAGEMENT_WATCHER,
  GET_MEASURE_GENERAL_WATCHER,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_INFO_WATCHER,
  GET_DIMENSIONS_RANK_WATCHER,
  GET_DETAIL_COUNTS_WATCHER,
  GET_MEASURE_RATE_WATCHER,
} from "./constants"

import {
  getDimensionsSuccess,
  getDimensionsFailed,
  getStatusSuccess,
  getDivisionsMeasureSuccess,
  getDivisionsMeasureFailed,
  getQualitativeQuestionSuccess,
  getQualitativeQuestionWatcher,
  getDateProgSuccess,
  getStatusWatcher,
  countCollaboratorsSuccess,
  getRecipientsSuccess,
  getRecipientsWatcher,
  getDatesSuccess,
  getDivisionsMeasureWatcher,
  getSurveysTypeSuccess,
  getLeadersDetailsSuccess,
  getLeadersDetailsFailed,
  getLeadersDetailsWatcher,
  getDatesWatcher,
  getDateProgWatcher,
  sendTestMeasureFailed,
  getDivisionsTreeMeasureSuccess,
  getDivisionsTreeMeasureFailed,
  setIncludeSubDivisionsWatcher,
  getMeasureColorRangeSuccess,
  getRecipientsSegmentsFailed,
  getRecipientsSegmentsSuccess,
  getRecipientsSegmentsWatcher,
  getLeadersSegmentsSuccess,
  getLeadersSegmentsFailed,
  getPossibleRecipientsSuccess,
  getPossibleRecipientsFailed,
  addCollaboratorsSuccess,
  addCollaboratorsFailed,
  getMeasureEngagementFailed,
  getMeasureEngagementSuccess,
  getMeasureGeneralSuccess,
  getMeasureGeneralFailed,
  getMeasureTotalSuccess,
  getMeasureTotalFailed,
  getMeasureInfoSuccess,
  getMeasureInfoFailed,
  getPossibleRecipientsWatcher,
  getDimensionsRankSuccess,
  getDimensionsRankFailed,
  getDetailCountsSuccess,
  getDetailCountsFailed,
  getMeasureRateFailed,
  getMeasureRateSuccess,
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"
import {
  getMeasureEngagementReportApi,
  getMeasureReportApi,
  getMeasureTotalReportApi,
} from "../../utils/routes/routes-report"

function messageProgress(messagex) {
  message.loading(messagex, 10000000000)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

function getDimensionsApi(params) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params}/dimensions`,
  })
}

function getQuestionsApi(params) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params}/questions`,
  })
}

export function* getDimensionsSaga(params) {
  try {
    const [dimensionsApi, questionsApi] = yield all([
      call(getDimensionsApi, params.payload),
      call(getQuestionsApi, params.payload),
    ])
    const dimensions = dimensionsApi.data.data
    const questions = questionsApi.data.data
    questions.map((e) => {
      e.id = parseInt(e.id_dimension + Math.floor(Math.random() * 1000000 + 1))
    })
    const result = {}
    result.metric_total = dimensionsApi.data.metric_total
    result.dimensions = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    result.dimensions.forEach(addLevel(1))
    yield put(getDimensionsSuccess(result))
  } catch (e) {
    yield put(getDimensionsFailed())
  }
}

function getMeasureDetailApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/details`,
  })
}

function getDetailCountsApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/measure/${idMeasure}/details`,
  })
}


function getStatusApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/reports/measure/${idMeasure}/status`,
  })
}

function getEngagementApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/divisions/engagement`,
  })
}

function getDimensionRankApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/dimensions/rank`,
  })
}

export function* getDimensionsRankSaga(action) {
  try {
    const { data } = yield call(getDimensionRankApi, action.payload)
    yield put(getDimensionsRankSuccess(data))
  } catch (error) {
    yield put(getDimensionsRankFailed())
  }
}

export function* getStatusSaga(action) {
  try {
    const [
      /* { status, data: measureDetail }, */
      { status, data: measureStatus },
    ] = yield all([
      /* call(getMeasureDetailApi, action.payload), */
      call(getStatusApi, action.payload),
    ])

    // const measureData = yield call(getMeasureDetailApi, action.payload)
    if (status === 200) {
      // let response = { ...measureStatus.data, ...measureStatus.data.measure }
      yield put(getStatusSuccess({ ...measureStatus, measure: {} }))
    }
    // yield put(getQualitativeQuestionWatcher(data.measure.survey.id_survey))
  } catch (error) {
    console.log(error)
  }
}

/* export function* getStatusSaga(action) {
  try {
    const measure = yield call(getMeasureDetailApi, action.payload)
    if (measure === 200) {
      yield put(getStatusSuccess(measure.data))
      yield put(getQualitativeQuestionWatcher(measure.data.measure.id_survey))
    }
  } catch (error) {}
} */

function getDivisionMeasureApi(idMeasure, params) {
  const includeSubdivisions = Number(!params.include)
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/divisions?include=${includeSubdivisions}`,
  })
}

function getDivisionMeasureV3Api(idMeasure, params) {
  const includeSubdivisions = Number(!params.include)
  const page = params.page || 1
  const perPage = params.per_page || 15
  const search = params.search || ""
  let url = `${process.env.API_URL}v3/measure/${idMeasure}/divisions?include=${includeSubdivisions}&paginate=1&page=${page}&per_page=${perPage}`
  if (search) {
    url += `&search=${encodeURIComponent(search)}`
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url,
  })
}

function getCollaboratorsMeasureApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/recipients`,
  })
}

function getRecipientsSegmentsApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/recipients/segments`,
  })
}

export function* getRecipientsSegmentsSaga(action) {
  try {
    const { status, data } = yield call(
      getRecipientsSegmentsApi,
      action.payload
    )

    if (status === 200) {
      yield put(getRecipientsSegmentsSuccess(data))
    }
  } catch (error) {
    yield put(getRecipientsSegmentsFailed())
  }
}

function getLeadersSegmentsApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/teamleader`,
  })
}

export function* getLeadersSegmentsSaga(action) {
  try {
    const { status, data } = yield call(getLeadersSegmentsApi, action.payload)
    if (status === 200) {
      yield put(getLeadersSegmentsSuccess(data))
    }
  } catch (error) {
    yield put(getLeadersSegmentsFailed())
  }
}

function getDivisionReportsMeasureApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/divisions`,
  })
}

export function* getDivisionMeasureSaga(action) {
  try {
    const { idMeasure, params } = action.payload
    
    if(!params.include || params.id_measure_status === 5) {
      const [divisions, collaborators, resultColumn] = yield all([
        call(getDivisionMeasureApi, idMeasure, params),
        call(getCollaboratorsMeasureApi, idMeasure),
        call(getDivisionReportsMeasureApi, idMeasure),
      ])
  
      divisions.data = divisions.data.data.map((item) => {
        return {
          ...item,
          level_original: item.level,
          result:
            resultColumn.data.data.find(
              (it) => it.id_division === item.id_division
            ) || {},
          collaborators: collaborators.data.data.filter(
            (it) => it.id_division === item.id_division
          ),
        }
      })
  
      const newData = divisions.data.map((item) => {
        return {
          ...item,
          children: collaborators.data.data.filter(
            (it) => it.id_division === item.id_division
          ),
        }
      })
  
      let dataTree = generateTree(
        "id_division",
        "id_division_parent",
        divisions.data,
        "children",
        false
      )
  
      dataTree = orderBy(dataTree, ["level"], ["asc"])
      dataTree.forEach(addLevel(1, "children"))
      let removeAll0 = []
      if (params.include) {
        removeAll0 = newData.filter((item) => item.children.length)
      } else {
        removeAll0 = newData.map((row) => {
          if (row.children.length === 0) {
            delete row.children
          }
          return row
        })
      }
      const orderAsc = orderBy(removeAll0, ["name"], ["asc"])

      if (divisions.status === 200) {
        yield put(countCollaboratorsSuccess(collaborators.data.data.length))
        yield put(setIncludeSubDivisionsWatcher(true))
        yield put(getDivisionsMeasureSuccess(orderAsc))
        yield put(getDivisionsTreeMeasureSuccess(dataTree))
      }
    } else {
     
      const [divisions] = yield all([
        call(getDivisionMeasureV2Api, idMeasure, params),
      ])

      let divisionsFirst = divisions.data.data

      let divisionsData = divisionsFirst.map((item) => {
        return {
          ...item,
          children: item.collaborators
        }
      })

      let dataTree = generateTree(
        "id_division",
        "id_division_parent",
        divisionsFirst,
        "children",
        false
      )

      dataTree = orderBy(dataTree, ["level"], ["asc"])
      dataTree.forEach(addLevel(1, "children"))

      if (params.include) {
        divisionsData = divisionsData.filter((item) => item.children.length)
      } else {
        divisionsData = divisionsData.map((row) => {
          if (row.children.length === 0) {
            delete row.children
          }
          return row
        })
      }
      let data = orderBy(divisionsData, ["name"], ["asc"])

      let collaboratorsCount = divisionsData.reduce((total, item) => {
        if (Array.isArray(item.children)) {
          return total + item.children.length;
        }
        return total;
      }, 0);
      
      if (divisions.status === 200) {
        yield put(countCollaboratorsSuccess(collaboratorsCount))
        yield put(setIncludeSubDivisionsWatcher(true))
        yield put(getDivisionsMeasureSuccess(data))
        yield put(getDivisionsTreeMeasureSuccess(dataTree))
      }
    }
    
  } catch (error) {
    console.log(error)
    yield put(getDivisionsMeasureFailed())
    yield put(getDivisionsTreeMeasureFailed())
  }
}

/**
 * Nueva versión simplificada - Solo usa endpoint V3
 * Reemplaza getDivisionMeasureSaga eliminando código legacy
 */
export function* getDivisionMeasureV3Saga(action) {
  try {
    const { idMeasure, params } = action.payload

    const { data: response } = yield call(getDivisionMeasureV3Api, idMeasure, params)

    const divisionsData = response.data.map((item) => ({
      ...item,
      children: item.collaborators
    }))

    let dataTree = generateTree(
      "id_division",
      "id_division_parent",
      response.data,
      "children",
      false
    )

    dataTree = orderBy(dataTree, ["level"], ["asc"])
    dataTree.forEach(addLevel(1, "children"))

    let processedData = params.include
      ? divisionsData.filter((item) => item.children?.length)
      : divisionsData.map((row) => {
          if (!row.children?.length) {
            delete row.children
          }
          return row
        })

    processedData = orderBy(processedData, ["name"], ["asc"])

    const collaboratorsCount = divisionsData.reduce((total, item) => {
      return total + (Array.isArray(item.children) ? item.children.length : 0)
    }, 0)

    const meta = response.meta || {
      current_page: 1,
      last_page: 1,
      per_page: 15,
      total: processedData.length,
      total_collaborators: collaboratorsCount
    }

    yield put(countCollaboratorsSuccess(meta.total_collaborators || collaboratorsCount))
    yield put(setIncludeSubDivisionsWatcher(true))
    yield put(getDivisionsMeasureSuccess({ data: processedData, meta }))
    yield put(getDivisionsTreeMeasureSuccess(dataTree))

  } catch (error) {
    console.log(error)
    yield put(getDivisionsMeasureFailed())
    yield put(getDivisionsTreeMeasureFailed())
  }
}

// GET QUEALITATIVE APU
function getQualitativeApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idMeasure}/questions/qualitative`,
  })
}

export function* getQualitativeSaga(action) {
  try {
    const { status, data } = yield call(getQualitativeApi, action.payload)

    if (status === 200) {
      yield put(getQualitativeQuestionSuccess(data.data))
    }
  } catch (e) {}
}

// GET DATE PRO
function getDateProgApi(idSurvey) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idSurvey}/automatic/resend`,
  })
}

export function* getDateProgSaga(action) {
  try {
    const { status, data } = yield call(getDateProgApi, action.payload)

    if (status === 200) {
      yield put(getDateProgSuccess(data.data))
    }
  } catch (e) {}
}

// MEASUREMENT EDIT NAME
export function editMeasurementNameApi({ idMeasurement, params = {} }) {
  return axios.request({
    method: "put",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}`,
    data: params,
  })
}

export function* editMeasurementNameSaga(action) {
  try {
    const data = yield call(editMeasurementNameApi, action.payload)

    yield put(getStatusWatcher(action.payload.idMeasurement))
  } catch (error) {}
}

// DELETE MEASURE
export function deleteMeasureApi(idMeasure) {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}`,
  })
}

export function* deleteMeasureSaga(action) {
  try {
    const { status } = yield call(deleteMeasureApi, action.payload)

    if (status === 200) {
      yield call(messageSuccess, "La medición ha sido eliminada.")
      yield put(push("/models/measure-history"))
    }
  } catch (error) {
    yield call(messageFailed, "No se pudo eliminar la medición.")
  }
}

// RESEND SURVEY
export function resendSurveyApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/resend/email`,
  })
}

export function* resendSurveySaga(action) {
  try {
    yield call(messageProgress, "Reenviando...")

    const { idMeasure } = action.payload
    const { status } = yield call(resendSurveyApi, idMeasure)

    if (status === 200) {
      yield call(messageDestroy)
      yield put(getStatusWatcher(idMeasure))
      yield put(getDivisionsMeasureWatcher(action.payload))
      yield call(messageSuccess, "La encuesta ha sido reenviada.")
      yield put(getRecipientsSegmentsWatcher(idMeasure))
      
      // Actualizar tabla de líderes
      const measureStatusImmutable = yield select((state) => 
        state.get("measurementDetails")?.get("measureStatus")
      )
      const measureStatus = measureStatusImmutable?.toJS 
        ? measureStatusImmutable.toJS() 
        : measureStatusImmutable || {}
      const idStatus = measureStatus?.id_measure_status
      if (idStatus) {
        yield put(getLeadersDetailsWatcher({
          id_measure: idMeasure,
          params: { id_measure_status: idStatus }
        }))
      }
    }
  } catch (error) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al reenviar la encuesta.")
  }
}

// GET RECIPIENTS
export function getRecipientsApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/employee/potential`,
  })
}

export function* getRecipientsSaga(action) {
  try {
    const { status, data } = yield call(getRecipientsApi, action.payload)

    if (status === 200) {
      yield put(getRecipientsSuccess(data))
    }
  } catch (error) {
    catchError({ sendToErrorPage: true, error })
  }
}

// POST RECIPIENTS
export function postRecipientsApi({ idMeasure, params }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/add/employee/potential`,
    data: { ...params },
  })
}

export function* postRecipientsSaga(action) {
  try {
    const { status } = yield call(postRecipientsApi, action.payload)

    if (status === 200) {
      yield call(messageSuccess, "Se agregaron los nuevos destinatarios.")
      yield put(getStatusWatcher(action.payload.idMeasure))
      yield put(getRecipientsWatcher(action.payload.idMeasure))

      if (action.payload.id_survey_type === 2) {
        yield put(getLeadersDetailsWatcher(action.payload.idMeasure))
      } else {
        yield put(getDivisionsMeasureWatcher(action.payload))
      }
    }
  } catch (error) {}
}

// GET DATES
export function getDatesApi({ idMeasure, params = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/wizard/schedule`,
    data: params,
  })
}

export function* getDatesSaga(action) {
  try {
    const measure = yield call(getMeasureDetailApi, action.payload.idMeasure)
    const { status, data } = yield call(getDatesApi, action.payload)
    if (status === 200) {
      yield put(getDatesSuccess(data.data))
      if (!isEmpty(action.payload.params)) {
        editScheduleMeasureSegment(
          measure.data.data.measure.name,
          action.payload.params.editChangesSegment,
          action.payload.params.date_resend
        )
        yield put(getStatusWatcher(action.payload.idMeasure))
        yield put(getDateProgWatcher(action.payload.idMeasure))
        yield put(getDatesWatcher({ idMeasure: action.payload.idMeasure }))
      }
    }
  } catch (error) {
    catchError({ sendToErrorPage: true, error })
    yield put(getDatesWatcher({ idMeasure: action.payload.idMeasure }))
  }
}

// EDIT DATES
export function editDatesApi({ idMeasurement, params }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasurement}/complete/step`,
    data: params,
  })
}

export function* editDatesSaga(action) {
  try {
    const data = yield call(editDatesApi, action.payload)
  } catch (error) {}
}

/* DOWNLOAD */
function getRecipientsExcelApi(idSurvey) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/reports/measure/${idSurvey}/export/xlsx/download`,
  })
}

function getRecipientsExcelProgress() {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/reports/measure/export/xlsx/progress`,
  })
}

function downloadRecipientsUrl(url) {
  location.replace(url)
}

export function* downloadRecipientsSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getRecipientsExcelApi, action.payload)
    let data

    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getRecipientsExcelProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo descargado")
    yield call(downloadRecipientsUrl, data.data[0].url)
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar archivo")
  }
}

// GET SURVEYS TYPE
export function getSurveysTypeApi(typeSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/surveys`,
    params: { "filter[filterBySurveyType]": typeSurvey },
  })
}

export function getMeasureRateApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/measure/${idMeasure}/rate`,
  })
}

export function* getSurveysTypeSaga(action) {
  try {
    const { status, data } = yield call(getSurveysTypeApi, action.payload)

    if (status === 200) {
      yield put(getSurveysTypeSuccess(data.data))
    }
  } catch (error) {}
}

// GET LEADERS
export function getLeadersDetailsCountApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/leaders?anonymity=false`,
  })
}

export function getLeadersDetailsApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/teamleader`,
  })
}

export function getLeadersDetailsV2Api(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}v2/measure/${idMeasure}/teamleader`,
  })
}

export function getLeadersDetailsV3Api(idMeasure, params) {
  const page = params.page || 1
  const perPage = params.per_page || 15
  const search = params.search || ""
  let url = `${process.env.API_URL}v3/measure/${idMeasure}/teamleader?paginate=1&page=${page}&per_page=${perPage}`
  if (search) {
    url += `&search=${encodeURIComponent(search)}`
  }
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url,
  })
}

export function getLeadersDetailsRecipientsApi(idMeasure) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/recipients`,
  })
}

function getLeadersReportsMeasureApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${idMeasure}/leaders`,
  })
}

export function* getLeadersDetailsSaga(action) {
  const { id_measure, params = {} } = action.payload
  const isStatus5 = params.id_measure_status === 5

  try {
    if (isStatus5) {
      // Para status 5, traer también los reports para la columna "Resultado"
      const [leaders, resultColumn] = yield all([
        call(getLeadersDetailsV3Api, id_measure, params),
        call(getLeadersReportsMeasureApi, id_measure),
      ])

      const leadersData = leaders.data.data.map((item) => {
        return {
          ...item,
          result:
            resultColumn.data.data.find((it) => it.id === item.id_position) || {},
          children: item.children || item.collaborators || [],
        }
      })

      const removeAll0 = filter(leadersData, (item) => item.collaborators_quantity)
      const countAllCollaborators = flatMap(
        leadersData,
        (item) => Number(item.collaborators_quantity) || 0
      )
      const orderAsc = orderBy(removeAll0, ["full_name"], ["asc"])

      if (leaders.status === 200) {
        const totalCollaborators = (leaders.data.meta && leaders.data.meta.total_collaborators) || sum(countAllCollaborators)
        const meta = {
          ...(leaders.data.meta || { current_page: 1, last_page: 1, per_page: 15, total: orderAsc.length }),
          total_collaborators: totalCollaborators,
        }
        yield put(countCollaboratorsSuccess(totalCollaborators))
        yield put(getLeadersDetailsSuccess({ data: orderAsc, meta }))
      }
    } else {
      // Para otros estados, usar V3 sin reports
      const [leaders] = yield all([
        call(getLeadersDetailsV3Api, id_measure, params),
      ])

      const leadersData = leaders.data.data.map((item) => {
        return {
          ...item,
          children: item.children || item.collaborators || [],
        }
      })

      const removeAll0 = filter(leadersData, (item) => item.collaborators_quantity)
      const countAllCollaborators = flatMap(
        leadersData,
        (item) => Number(item.collaborators_quantity) || 0
      )
      const orderAsc = orderBy(removeAll0, ["full_name"], ["asc"])

      if (leaders.status === 200) {
        const totalCollaborators = (leaders.data.meta && leaders.data.meta.total_collaborators) || sum(countAllCollaborators)
        const meta = {
          ...(leaders.data.meta || { current_page: 1, last_page: 1, per_page: 15, total: orderAsc.length }),
          total_collaborators: totalCollaborators,
        }
        yield put(countCollaboratorsSuccess(totalCollaborators))
        yield put(getLeadersDetailsSuccess({ data: orderAsc, meta }))
      }
    }
  } catch (error) {
    console.log(error)
    yield put(getLeadersDetailsFailed())
  }
}

// STEP THREE
export function* sendTestMeasureSaga(action) {
  try {
    const { status, data } = yield call(sendTestMeasure, action.payload)
    if (status === 200) {
      yield call(messageSuccess, data.message)
    }
  } catch (error) {
    yield put(sendTestMeasureFailed())
  }
}

// POST EXPORT REPORT SAGA
export function* postExportReportSaga(action) {
  try {
    yield call(messageProgress, "Descargando reporte")
    const {
      data: {
        data: { result },
      },
    } = yield call(exportReport, action.payload)

    yield call(messageDestroy)

    window.open(result.url, "_blank")
    message.success("Se ha generado el reporte correctamente.", 5)
  } catch (error) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar reporte")
  }
}

export function* deleteCollDivSaga(action) {
  const { idMeasure, idEmployee, idDivision, idSurveyType } = action.payload

  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "DELETE",
      endpoint: idEmployee
        ? `reports/measure/${idMeasure}/employee/${idEmployee}`
        : `reports/measure/${idMeasure}/division/${idDivision}`,
    })

    const [collaborators] = yield all([
      call(getCollaboratorsMeasureApi, idMeasure),
    ])

    yield call(messageSuccess, data.data.msj)
    yield put(getStatusWatcher(idMeasure))
    yield put(getRecipientsWatcher(idMeasure))
    yield put(getPossibleRecipientsWatcher({ idMeasure }))
    yield put(getStatusWatcher(idMeasure))
    yield put(countCollaboratorsSuccess(collaborators.data.data.length))
    if (idSurveyType === 2) {
      yield put(getLeadersDetailsWatcher(idMeasure))
    } else {
      yield put(
        getDivisionsMeasureWatcher({
          idMeasure,
          params: { include: true },
        })
      )
    }
  } catch (err) {
    returnMessage(err)
  }
}

export function* resendCollDivSaga(action) {
  const { idMeasure, idEmployee, idDivision } = action.payload

  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: idEmployee
        ? `measure/${idMeasure}/employee/${idEmployee}/resend/email`
        : `measure/${idMeasure}/division/${idDivision}/resend/email`,
    })

    yield call(messageSuccess, "Encuesta reenviada.")
    yield put(getStatusWatcher(action.payload.idMeasure))
    // yield put(getDivisionsMeasureWatcher(action.payload))
    yield put(getRecipientsWatcher(action.payload.idMeasure))
    yield put(getRecipientsSegmentsWatcher(idMeasure))
    
    // Actualizar tabla de líderes
    const measureStatusImmutable = yield select((state) => 
      state.get("measurementDetails")?.get("measureStatus")
    )
    // Convertir a JS si es Immutable, o usar directamente si ya es objeto
    const measureStatus = measureStatusImmutable?.toJS 
      ? measureStatusImmutable.toJS() 
      : measureStatusImmutable || {}
    const idStatus = measureStatus?.id_measure_status
    if (idStatus) {
      yield put(getLeadersDetailsWatcher({
        id_measure: idMeasure,
        params: { id_measure_status: idStatus }
      }))
    }
  } catch (err) {
    returnMessage(err)
  }
}

// MEASURE COLOR RANGE
function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

function getPossibleRecipientsApi(idMeasure) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/possible/recipients`,
  })
}

export function* getPossibleRecipientsSaga(action) {
  try {
    const { data: response } = yield call(
      getPossibleRecipientsApi,
      action.payload.idMeasure
    )
    yield put(getPossibleRecipientsSuccess(response))
  } catch (e) {
    yield put(getPossibleRecipientsFailed())
  }
}

function addCollaboratorsApi(payload) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${payload.idMeasure}/add/recipients`,
    data: payload,
  })
}

export function* addCollaboratorsSaga(action) {
  try {
    const data = yield call(addCollaboratorsApi, action.payload)
    yield put(addCollaboratorsSuccess())
    yield put(getStatusWatcher(action.payload.idMeasure))
    yield put(getRecipientsWatcher(action.payload.idMeasure))

    if (action.payload.idSurveyType === 2) {
      yield put(getLeadersDetailsWatcher(action.payload.idMeasure))
    } else {
      yield put(
        getDivisionsMeasureWatcher({
          idMeasure: action.payload.idMeasure,
          params: { include: true },
        })
      )
    }
  } catch (e) {
    yield put(addCollaboratorsFailed())
  }
}

export function* getMeasureEngagementSaga(action) {
  try {
    const dataStatus = action.payload
    dataStatus.params.id_measure = action.payload.idMeasure
    const { data: resultTotal } = yield call(
      getMeasureEngagementReportApi,
      dataStatus.params
    )
    yield put(getMeasureEngagementSuccess(resultTotal))
  } catch (e) {
    yield put(getMeasureEngagementFailed())
  }
}

export function* getMeasureGeneralSaga(action) {
  try {
    const dataStatus = action.payload
    dataStatus.params.id_measure = action.payload.idMeasure
    const { data: resultMeasure } = yield call(
      getMeasureReportApi,
      dataStatus.params
    )
    yield put(getMeasureGeneralSuccess(resultMeasure))
  } catch (e) {
    yield put(getMeasureGeneralFailed())
  }
}

export function* getMeasureTotalSaga(action) {
  try {
    const dataStatus = action.payload
    dataStatus.params.id_measure = action.payload.idMeasure
    const { data: resultTotal } = yield call(
      getMeasureTotalReportApi,
      dataStatus.params
    )
    yield put(getMeasureTotalSuccess(resultTotal))
  } catch (e) {
    yield put(getMeasureTotalFailed())
  }
}

function getMeasureInfoApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.idMeasure}/info`,
    params: { id_segment: params.id_segment },
  })
}

export function* getMeasureInfoSaga(action) {
  try {
    const { data: response } = yield call(getMeasureInfoApi, action.payload)
    yield put(getMeasureInfoSuccess(response.data))
  } catch (e) {
    yield put(getMeasureInfoFailed())
  }
}


export function* getDetailCountsSaga(action) {
  try {
    const { data: response } = yield call(getDetailCountsApi, action.payload)
    yield put(getDetailCountsSuccess(response.data))
  } catch (e) {
    yield put(getDetailCountsFailed())
  }
}

export function* getMeasureRateSaga(action) {
  try {
    const { data: response } = yield call(getMeasureRateApi, action.payload)
    yield put(getMeasureRateSuccess(response.data))
  } catch (error) {
    console.log(error)
    yield put(getMeasureRateFailed())
  }
}

// Individual exports for testing
export default function* measurementDetailsSaga() {
  yield takeLatest(SEND_TEST_MEASURE_WATCHER, sendTestMeasureSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GET_STATUS_WATCHER, getStatusSaga)
  yield takeLatest(GET_DIVISIONS_MEASURE_WATCHER, getDivisionMeasureV3Saga)
  yield takeLatest(GET_QUALITATIVE_QUES_WATCHER, getQualitativeSaga)
  yield takeLatest(GET_DATE_PROG_WATCHER, getDateProgSaga)
  yield takeLatest(EDIT_MEASUREMENT_NAME_WATCHER, editMeasurementNameSaga)
  yield takeLatest(DELETE_MEASURE_WATCHER, deleteMeasureSaga)
  yield takeLatest(RESEND_SURVEY_WATCHER, resendSurveySaga)
  yield takeLatest(GET_RECIPIENTS_WATCHER, getRecipientsSaga)
  yield takeLatest(POST_RECIPIENTS_WATCHER, postRecipientsSaga)
  yield takeLatest(GET_DATES_WATCHER, getDatesSaga)
  yield takeLatest(EDIT_DATES_WATCHER, editDatesSaga)
  yield takeLatest(DOWNLOAD_RECIPIENTS_WATCHER, downloadRecipientsSaga)
  yield takeLatest(GET_SURVEYS_TYPE_WATCHER, getSurveysTypeSaga)
  yield takeLatest(GET_LEADERS_DETAILS_WATCHER, getLeadersDetailsSaga)
  yield takeLatest(POST_EXPORT_REPORT_WATCHER, postExportReportSaga)
  yield takeLatest(DELETE_CD_WATCHER, deleteCollDivSaga)
  yield takeLatest(RESEND_CD_WATCHER, resendCollDivSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_RECIPIENTS_SEGMENTS_WATCHER, getRecipientsSegmentsSaga)
  yield takeLatest(GET_LEADERS_SEGMENTS_WATCHER, getLeadersSegmentsSaga)
  yield takeLatest(GET_POSSIBLE_RECIPIENTS_WATCHER, getPossibleRecipientsSaga)
  yield takeLatest(ADD_COLLABORATORS_WATCHER, addCollaboratorsSaga)
  yield takeLatest(GET_MEASURE_ENGAGEMENT_WATCHER, getMeasureEngagementSaga)
  yield takeLatest(GET_MEASURE_GENERAL_WATCHER, getMeasureGeneralSaga)
  yield takeLatest(GET_MEASURE_TOTAL_WATCHER, getMeasureTotalSaga)
  yield takeLatest(GET_MEASURE_INFO_WATCHER, getMeasureInfoSaga)
  yield takeLatest(GET_DIMENSIONS_RANK_WATCHER, getDimensionsRankSaga)
  yield takeLatest(GET_DETAIL_COUNTS_WATCHER, getDetailCountsSaga)
  yield takeLatest(GET_MEASURE_RATE_WATCHER, getMeasureRateSaga)
}
